(() => {
  const body = document.querySelector('.aq-policy-privacy .shopify-policy__body .rte');
  if (!body || body.dataset.organized) return;
  body.dataset.organized = 'true';
  const emptyFieldLabels = new Set([
    'Purpose of collection:',
    'Source of collection:',
    'Disclosure for a business purpose:',
    'Personal Information collected:'
  ]);
  body.querySelectorAll('li').forEach((item) => {
    const text = item.textContent.replace(/\s+/g, ' ').trim();
    if (emptyFieldLabels.has(text)) item.remove();
  });
  body.querySelectorAll('p, ul, ol').forEach((element) => {
    if (!element.textContent.trim() && !element.querySelector('img, video, iframe')) element.remove();
  });
  let content;
  [...body.childNodes].forEach((node) => {
    if (node.nodeType === 1 && node.tagName === 'H1') {
      if (!node.textContent.trim()) { node.remove(); return; }
      const details = document.createElement('details');
      details.className = 'aq-policy-topic';
      const summary = document.createElement('summary');
      summary.textContent = node.textContent.trim();
      content = document.createElement('div');
      content.className = 'aq-policy-topic__body';
      details.append(summary, content);
      node.replaceWith(details);
    } else if (content) {
      content.append(node);
    }
  });
  body.querySelectorAll('table').forEach((table) => {
    const wrapper = document.createElement('div');
    wrapper.className = 'aq-policy-table';
    wrapper.tabIndex = 0;
    table.before(wrapper);
    wrapper.append(table);
  });
  const revealAnchor = () => {
    const target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    const topic = target?.closest('details');
    if (topic) topic.open = true;
  };
  revealAnchor();
  window.addEventListener('hashchange', revealAnchor);
})();
